/* eslint "react/destructuring-assignment": "off" */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { AnimatePresence, motion } from "framer-motion";
import omit from "just-omit";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { MenuList } from "../../molecules";
import { LinkContext } from "../../../context";
import { LanguagesIcon } from "../../icons";
var ref;
var DEFAULT_RENDER_HEADER_LABEL = function(item) {
    return (ref = item === null || item === void 0 ? void 0 : item.label) !== null && ref !== void 0 ? ref : null;
};
export function NavbarMobileMenu(param) {
    var isOpen = param.isOpen, navItems = param.navItems, callToAction = param.callToAction, languageSwitchAction = param.languageSwitchAction, _renderHeaderLabel = param.renderHeaderLabel, renderHeaderLabel = _renderHeaderLabel === void 0 ? DEFAULT_RENDER_HEADER_LABEL : _renderHeaderLabel;
    var LinkComponent = useContext(LinkContext).LinkComponent;
    var ref = _slicedToArray(useState([]), 2), activeIndexPath = ref[0], setActiveIndexPath = ref[1];
    var ref1 = _slicedToArray(useMemo(function() {
        if (activeIndexPath.length) {
            var prevItem = null;
            var item = navItems[activeIndexPath[0]];
            activeIndexPath.slice(1).forEach(function(index) {
                var ref;
                prevItem = item;
                var ref1;
                item = (ref1 = item === null || item === void 0 ? void 0 : (ref = item.navItems) === null || ref === void 0 ? void 0 : ref[index]) !== null && ref1 !== void 0 ? ref1 : null;
            });
            return [
                item,
                prevItem
            ];
        }
        return [
            null,
            null
        ];
    }, [
        activeIndexPath
    ]), 2), currentItem = ref1[0], previousItem = ref1[1];
    var menuListProps = useMemo(function() {
        var headerLabel = previousItem || currentItem ? renderHeaderLabel(previousItem) : null;
        var ref;
        var items = ((ref = currentItem === null || currentItem === void 0 ? void 0 : currentItem.navItems) !== null && ref !== void 0 ? ref : navItems).map(function(item, index) {
            var ref;
            return _objectSpreadProps(_objectSpread({}, omit(item, "navItems")), {
                highlighted: false,
                onClick: ((ref = item.navItems) === null || ref === void 0 ? void 0 : ref.length) ? function() {
                    setActiveIndexPath(_toConsumableArray(activeIndexPath).concat([
                        index
                    ]));
                } : undefined
            });
        });
        if (currentItem) {
            items.splice(0, 0, _objectSpreadProps(_objectSpread({}, omit(currentItem, "navItems")), {
                highlighted: true,
                onClick: undefined
            }));
        }
        return {
            header: headerLabel ? {
                label: headerLabel,
                onClick: function() {
                    setActiveIndexPath(activeIndexPath.slice(0, -1));
                }
            } : undefined,
            items: items,
            callToAction: callToAction
        };
    }, [
        currentItem,
        previousItem,
        navItems,
        callToAction,
        activeIndexPath
    ]);
    useEffect(function() {
        if (!isOpen) {
            setActiveIndexPath([]);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ React.createElement(AnimatePresence, null, isOpen && /*#__PURE__*/ React.createElement(motion.div, {
        key: "mobilemenu",
        initial: {
            opacity: 0
        },
        exit: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        className: "fixed flex items-start overflow-auto bg-bg-default left-0 bottom-0 w-full z-20 top-[4.375rem] md:top-[5.375rem]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container"
    }, /*#__PURE__*/ React.createElement(MenuList, _extends({}, menuListProps)), !!languageSwitchAction && /*#__PURE__*/ React.createElement(LinkComponent, _extends({
        className: "flex items-center justify-between px-3 py-6 border-b border-b-fg-inbetween text-body.base font-medium text-brand-primary-base"
    }, languageSwitchAction), /*#__PURE__*/ React.createElement("span", null, languageSwitchAction.label), /*#__PURE__*/ React.createElement(LanguagesIcon, {
        className: "block w-5 h-5"
    })))));
}

//# sourceMappingURL=NavbarMobileMenu.js.map